export enum HouseSubtype {
  DETACHED_HOUSE = 'DETACHED_HOUSE',
  SEMI_DETACHED_HOUSE = 'SEMI_DETACHED_HOUSE',
  TERRACED_HOUSE = 'TERRACED_MIDDLE_HOUSE',
  MULTI_FAMILY_HOUSE = 'MULTI_FAMILY_HOUSE',
}

export enum ApartmentSubtype {
  BASEMENT = 'SOUTERRAIN',
  ATTIC = 'ATTIC',
  GROUND_FLOOR = 'GROUND_FLOOR',
  DUPLEX = 'DUPLEX',
  APARTMENT = 'APARTMENT',
  LOFT = 'LOFT',
}
